<div class="modal-container" [class.show]="isModalVisible">
    <div id="idlePopupModal" class="modal" [class.show]="isModalVisible">
        <div class="modal-content">
            <h2><b>Session Inactivity Warning</b></h2>
            <p>Your session will expire soon due to inactivity.</p>
            <div class="clock-style">
                <span>Time Remaining:</span>
                <span class="time-in-mins">{{ secondTimerLeft }}</span>
            </div>

            <div class="button-group">
                <button (click)='continue()' class="btn btn-primary">Continue Session</button>
                <button (click)='logout()' class="btn btn-secondary">Logout</button>
            </div>
        </div>
    </div>
</div>
